export default [
  {
    label: 'awards home',
    value: 'awards',
  },
  {
    label: 'credit cards',
    value: 'awards-credit-cards-2022',
  },
  {
    label: 'mortgages',
    value: 'awards-mortgages-2022',
  },
  {
    label: 'investment accounts',
    value: 'awards-investing-2022',
  },
  {
    label: 'bank accounts',
    value: 'awards-banking-2022',
  },
  {
    label: 'personal loans',
    value: 'awards-personal-loans-2022',
  },
  {
    label: 'student loans',
    value: 'awards-student-loans-2022',
  },
  {
    label: 'insurance',
    value: 'awards-insurance-2022',
  },
  {
    label: 'travel rewards',
    value: 'awards-travel-2022',
  },
];
